export const homemainMenuRouter = [{
  path: 'home',
  icon: ' iconfont iconhome',
  name: 'HomeIndex',
  title: '首页',
  component: () => import('@/views/gip/home/home.vue')
}]



// WEBPACK FOOTER //
// ./src/router/home/homeMain.js